// @flow
import styled from 'styled-components';
import Grid from 'styled-components-grid';
import {
  px, py, mx, mb
} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import theme from '@theme';
import { Pagination } from '@components';

export const StyledMainCover = styled.div`
  max-width: 1500px;
  margin: 0 auto;
  ${px(4)};
  ${breakpoint('tablet', 'desktop')`
  ${px(2)};
  `};
  ${breakpoint('mobile', 'tablet')`
  ${px(1)};
  `};
`;

export const StyledHeadlineText = styled(Grid)`
  justify-content: space-between;
  align-items: center;
  ${py(3)}
  ${px(3)}
  display: flex;
  flex-dirction: row;
  flex-wrap: wrap;
  font-weight: bold;
  font-size: 25px;
  ${breakpoint('mobile', 'desktop')`
  ${py(2)}
  // width:100%;
  ${px(1)}
  flex-direction:column-reverse;
  font-size: 22px;
`}
  ${breakpoint('mobile', 'tablet')`
  font-size: 18px;
`}
`;

export const StyledResult = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${theme.colors.gray};
  font-weight: bold;
  font-size: 18px;
  color: ${theme.colors.darkestGray};
  ${py(3)};
  ${mx(3)};
  ${breakpoint('mobile', 'desktop')`
  font-size: 12px;
  ${py(2)};
  ${mx(1)};
`}
`;

export const StyledPagination = styled(Pagination)`
  ${mb(4.5)}
  display: flex;
`;

export const StyledGridUnit = styled(Grid.Unit)`
  width: 100%;
`;

export const Headline = styled.h1`

`;

export const StyledH1Container = styled.h1`
  display: flex;
  justify-content:left;
  align-items:left;
  font-weight: 600;
  line-height: 1.4;
`;

export const StyledResetFilter = styled.button`
  background-color: white;
  color: #57a1bb;
  text-decoration: underline;
  font-size: 18px;
  font-weight: 400;
  line-height: 34px;
  border: none;
  border-radius: 5px;
  padding: 0px 10px;
  cursor: pointer;
`;
